import ErrorBoundary from 'shared/components/ErrorBoundary';
import Product from 'models/Product';
import PropTypes from 'prop-types';
import React from 'react';
import SoftkitDropdown from 'features/Product/components/SoftkitDropdown';
import Accordion  from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { startCase } from 'shared/utils/htmlHelpers';
import { withTheme } from '@material-ui/core/styles';

import styles from './styles.css';

export const standardDisplayTitle = startCase('standard product:');

/**
 * Handle display of soft kit items
 * @param {React props} props
 */
const Softkit = props => {
	const { handleSelection, theme, product } = props;
	const kitComponents = product.softkitComponents;

	return product.isSoftkit ? (
		<ErrorBoundary>
			<div className={styles['product-expandable-spacer']}>
				<Accordion defaultExpanded>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="subtitle2">Kit Options</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<div className={styles['softkit-container']}>
							{kitComponents.map(component => (
								<div key={component.mappingId}>
									<h5 style={{ fontSize: 15, color: theme.palette.text.secondary }}>
										{component.componentDescription && component.componentDescription.length > 0
											? startCase(component.componentDescription)
											: standardDisplayTitle}
									</h5>
									<SoftkitDropdown component={component} handleSelection={handleSelection} />
								</div>
							))}
						</div>
					</AccordionDetails>
				</Accordion>
			</div>
		</ErrorBoundary>
	) : null;
};

Softkit.propTypes = {
	handleSelection: PropTypes.func.isRequired,
	theme: PropTypes.instanceOf(Object).isRequired,
	product: PropTypes.instanceOf(Product).isRequired,
};

export default withTheme(Softkit);
